import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { EmployeeValesManager } from './EmployeeValesManager';

export interface EmployeeValesDialogProps {
  open: boolean;
  employeeId: number | null;
  employeeName?: string;
  onClose: () => void;
}

export function EmployeeValesDialog({
  open,
  employeeId,
  employeeName,
  onClose,
}: EmployeeValesDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {employeeName
          ? t('features.colaboradores.vales.dialogTitleNamed', { nome: employeeName })
          : t('features.colaboradores.vales.dialogTitle')}
        <IconButton onClick={onClose} aria-label={t('common.close')} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {employeeId !== null && <EmployeeValesManager employeeId={employeeId} />}
      </DialogContent>
    </Dialog>
  );
}
